import { toTitleCase } from './toTitleCase';

export const convertHours = (hoursObj) => {
	const daysOrder = [
		'monday',
		'tuesday',
		'wednesday',
		'thursday',
		'friday',
		'saturday',
		'sunday'
	];
	return daysOrder.map((day) => ({
		day,
		timings: toTitleCase(hoursObj[day]) || 'Closed'
	}));
};
